export default "__VITE_ASSET__94d342e7__"